import { createReducer } from "../reducer_utils";

const initialState = {
  data: null,
  generated_sitemaps: null,
  network_activity: []
};

const getNetworkActivityMessage = domain => `fetch_sitemap_${domain}`;
const addNetworkActivityMessage = (networkActivity, domain) => [...networkActivity, getNetworkActivityMessage(domain)];
const removeNetworkActivityMessage = (networkActivity, domain) => {
  return networkActivity.filter(msg => msg !== getNetworkActivityMessage(domain));
};

const fetchMoreActivityMessage=(networkActivity, domain)=>[...networkActivity, `load_more_sitemap_${domain}`];
const removeSitemapGenerationMessage = (network_activity, domain)=>{
  return network_activity.filter(msg => msg !== `generate_sitemap_${domain}`);
}

const addNetworkActivity=(state, action)=>{
  if(action.last_url_hash){
    return fetchMoreActivityMessage(state.network_activity, action.domain);
  }else{
    return addNetworkActivityMessage(state.network_activity, action.domain);
  }
}

const removeNetworkActivity=(state, action)=>{
  if(action.last_url_hash){
    return state.network_activity.filter(msg => msg !== `load_more_sitemap_${action.domain}`);
  }else{
    return removeNetworkActivityMessage(state.network_activity, action.domain);
  }
}

const fetchSitemapInProgress = (state, action) => ({
  ...state,
  network_activity: addNetworkActivity(state, action)
});

const fetchSitemapSuccess = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivity(state, action),
  data: {
    ...state["data"],
    [action.domain]: action.data
  }
});

const fetchSitemapFailed = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivity(state, action)
});

const generateSitemapInProgress = (state, action) => ({
  ...state,
  network_activity: [...state.network_activity, `generate_sitemap_${action.domain}`]
});

const generateSitemapSuccess = (state, action) => {
  return {
    ...state,
    network_activity: removeSitemapGenerationMessage(state.network_activity, action.domain),
    generated_sitemaps: {
      ...state["generated_sitemaps"],
      [action.domain]: action.data
    }
  }
};

const generateSitemapFailed = (state, action) => {
  return {
    ...state,
    network_activity: removeSitemapGenerationMessage(state.network_activity, action.domain)
  }
};

const logout = (state, _) => ({ ...state, ...initialState });

const sitemapReducer = createReducer(initialState, {
  FETCH_SITEMAP_IN_PROGRESS: fetchSitemapInProgress,
  FETCH_SITEMAP_SUCCESS: fetchSitemapSuccess,
  FETCH_SITEMAP_FAILED: fetchSitemapFailed,
  GENERATE_SITEMAP_IN_PROGRESS: generateSitemapInProgress,
  GENERATE_SITEMAP_SUCCESS: generateSitemapSuccess,
  GENERATE_SITEMAP_FAILED: generateSitemapFailed,
  LOGOUT: logout
});

export default sitemapReducer;
